import { Amount } from '@mews-commander/types';
import { LocalizedLabel } from '@mews-commander/ui';
import { TextKey } from '@mews-commander/enums';
import Balance from './Balance';
import InlineBalance from './InlineBalance';

interface AccountBalanceProps {
    amount?: Amount;
    inline?: boolean;
}

const AccountBalance = ({ amount, inline }: AccountBalanceProps) => {
    if (!amount) {
        return null;
    }

    const { value } = amount;

    if (value === 0) {
        return <LocalizedLabel textKey={TextKey.Balanced} as="div" />;
    }

    const BalanceComponent = inline ? InlineBalance : Balance;
    return <BalanceComponent amount={amount} />;
};

export default AccountBalance;
